const FIRST_TIME_BUYER = [
  { text: 'Yes', value: 'yes' },
  { text: 'No', value: 'no' },
];
export default FIRST_TIME_BUYER;



// WEBPACK FOOTER //
// ./src/constants/firstTimeBuyer.js